import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { renderChildren, text } from "../helpers";

var root = $.from_html(`<main></main>`);

export default function Page($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var main = root();
	let styles;

	$.action(main, ($$node, $$action_arg) => renderChildren?.($$node, $$action_arg), () => $$props.ctx);

	$.template_effect(
		($0, $1) => {
			$.set_class(main, 1, $0);
			$.set_attribute(main, 'data-density', $.get(p).density === "compact" ? "compact" : "normal");
			styles = $.set_style(main, '', styles, $1);
		},
		[
			() => `slex-page${$.get(p).variant ? ` slex-page--${text($.get(p).variant)}` : ""}${$.get(p).class ? ` ${text($.get(p).class)}` : ""}`,
			() => ({
				'max-width': text($.get(p).maxWidth, "1180px"),
				'padding-top': text($.get(p).paddingY, "3rem"),
				'padding-bottom': text($.get(p).paddingY, "3rem")
			})
		]
	);

	$.append($$anchor, main);
	$.pop();
}